<template>
  <div
    id="container"
    class="bg-primar-450"
  >
    <nav-header></nav-header>
    <router-view />
    <nav-footer />
  </div>
</template>

<script>
import NavHeader from './components/NavHeader';
import NavFooter from './components/NavFooter';


export default {
  components: { NavHeader, NavFooter },
  mounted() {
    
  },
  created() {
    
  }
};
</script>

<style>
</style>